<template>
  <div>
    <h4>Répondez aux questions secrètes</h4>
    <Alert
      type="info"
      title="Pourquoi ces questions ?"
      subtitle="Votre compte a été temporairement bloqué lors de votre dernière tentative de connexion. Nous voulons nous assurer que ce soit bien vous qui essayez de vous connecter."
    />

    <span>{{ question1Label }}</span>
    <div class="form-group" v-if="q1 !== 0">
      <input type="text" id="verifyR1" data-ob1-component="FormControlEmpty"
        :class="`form-control${verifyR1.length === 0 ? ' form-control-empty' : ''}`"
        :value="verifyR1" @input="$emit('update:verifyR1', $event.target.value)"
        aria-labelledby="label-verifyR1" required />
      <label id="label-verifyR1" class="form-control-placeholder" for="verifyR1">Réponse</label>
      <Alert v-if="errorResponse1" title="Réponse incorrecte." type="danger" />
    </div>

    <span>{{ question2Label }}</span>
    <div class="form-group" v-if="q2 !== 0">
      <input type="text" id="verifyR2" data-ob1-component="FormControlEmpty"
        :class="`form-control${verifyR2.length === 0 ? ' form-control-empty' : ''}`"
        :value="verifyR2" @input="$emit('update:verifyR2', $event.target.value)"
        aria-labelledby="label-verifyR2" required />
      <label id="label-verifyR2" class="form-control-placeholder" for="verifyR2">Réponse</label>
      <Alert v-if="errorResponse2" title="Réponse incorrecte." type="danger" />
    </div>

    <button
      @click="$emit('submit')"
      :disabled="isLoading || isBlocked || verifyR1.length === 0 || verifyR2.length === 0"
      class="btn btn-info mr-1 mb-1 mb-md-0"
      type="button"
    >
      Continuer
    </button>
  </div>
</template>

<script>
import Alert from '@/components/Alert/Alert'

export default {
  name: 'StepVerifyQuestions',
  components: { Alert },
  props: {
    q1: { type: Number, required: true },
    q2: { type: Number, required: true },
    verifyR1: { type: String, required: true },
    verifyR2: { type: String, required: true },
    allQuestions: { type: Array, required: true },
    isLoading: { type: Boolean, default: false },
    isBlocked: { type: Boolean, default: false },
    errorResponse1: { type: Boolean, default: false },
    errorResponse2: { type: Boolean, default: false },
  },
  emits: ['update:verifyR1', 'update:verifyR2', 'submit'],
  computed: {
    question1Label () {
      const q = this.allQuestions[this.q1 - 1]
      return q ? q.label : ''
    },
    question2Label () {
      const q = this.allQuestions[this.q2 - 1]
      return q ? q.label : ''
    },
  },
}
</script>
